import React from 'react';
import styled from 'styled-components';

import { stylesFor } from '../styles/utilities';

const Root = styled.footer`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 1600px;
  padding: 20px;
  width: 100%;

  ${stylesFor.mediumUp`
    padding: 40px 60px;
  `};

  ${stylesFor.largeUp`
    align-items: center;
    flex-direction: row;
    height: 100px;
    justify-content: flex-end;
  `};
`;

const Logo = styled.img`
  height: 20px;
  width: 95px;
  font-size: 14px;

  ${stylesFor.underLarge`
    margin-bottom: 20px;
  `};

  ${stylesFor.largeUp`
    height: 32px;
    margin-right: auto;
    width: 152px;
  `};
`;

const List = styled.div`
  display: flex;
  flex-direction: column;

  ${stylesFor.underLarge`
    flex-wrap: wrap;
    height: 100px; // Wrap after 3 links.
  `};

  ${stylesFor.largeUp`
    flex-direction: row;
  `};
`;

const Link = styled.a`
  color: ${props => props.theme.color.gray44};
  font-size: 12px;
  margin-right: 20px;
  text-decoration: none;

  ${stylesFor.underLarge`
    margin-bottom: 8px;

    &:last-of-type {
      margin-bottom: 40px;
    }
  `};
`;

const Copyright = styled.span`
  font-size: 12px;
`;

export default () => {
  return (
    <Root>
      <Logo src="images/microsoft.svg" />
      <List>
        <Link href="https://support.microsoft.com/en-us/contactus">
          Contact us
        </Link>
        <Link href="https://go.microsoft.com/fwlink/?LinkId=521839">
          Privacy &amp; cookies
        </Link>
        <Link href="https://go.microsoft.com/fwlink/?LinkID=206977">
          Terms of use
        </Link>
        <Link href="https://www.microsoft.com/trademarks">Trademarks</Link>
        <Link href="https://choice.microsoft.com/">About our ads</Link>
      </List>
      <Copyright>&copy; Microsoft 2018</Copyright>
    </Root>
  );
};



// WEBPACK FOOTER //
// ./src/components/footer.js